import styled from "styled-components";
import { Style } from "../../styles";

const Dropdown = styled.span`
  font-weight: 500;
  color: ${Style.color.brandPrimary};
`

export default Dropdown